import React, { Component } from 'react'
import classNames from 'classnames'
import Icon from '../Icon'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'

import '../../../assets/sass/components/plans/plans-compare-features.scss'
import PlanPriceCard from './PlanPriceCard'
import { Row, Col, Button } from 'react-bootstrap'

class PlansCompareFeatures extends Component {
    render() {
        const { showButtons } = this.props;
        return (
            <div className={classNames("plans-compare-features", {"pb-3": !showButtons})}>
                <Row noGutters>
                    <Col lg={3}>
                        {this.renderFeaturesNamesCol()}
                    </Col>
                    <Col lg={9}>
                        {this.renderPlanFeaturesCol()}
                    </Col>
                </Row>
            </div>
        )
    }

    renderFeaturesNamesCol = () => {
        const { features, showButtons } = this.props;

        return (
            <div className="plan-col plan-names-col">
                <div className="plan-col-header">
                    Features
                </div>
                <ul className="plan-col-body">
                    {
                        features.map(feature => (
                            <li className="plan-col-item" key={feature}>{feature}</li>
                        ))
                    }
                </ul>
                {showButtons && 
                    <div className="plan-col-footer"></div>}
            </div>
        )
    }

    renderPlanFeaturesCol = () => {
        const { plans, showButtons } = this.props;

        return (
            <Row noGutters>
                {
                    Object.entries(plans).map(([planName, planDetails]) => (
                        <Col lg={3} key={planName}>
                            <div className={classNames("plan-col plan-features-col", planName)}>
                                <div className="plan-col-header">
                                    {this.renderPlanPriceCard(planName)}
                                </div>
                                <ul className="plan-col-body">
                                    {
                                        planDetails['features'].map(feature => (
                                            <li className={classNames("plan-col-item", {available: feature['available']})} key={feature['name']}>
                                                <Icon icon={feature['available'] ? faCheckCircle : faTimesCircle} />
                                                <span>{feature['name']}</span>
                                            </li>
                                        ))
                                    }
                                </ul>
                                {showButtons &&
                                    <div className="plan-col-footer">
                                        {this.renderPlanSelectButton(planName)}
                                    </div>}
                            </div>
                        </Col>
                    ))
                }
            </Row>
        )
    }

    renderPlanPriceCard = (plan) => {
        const { price, info, hint } = this.props.plans[plan];

        return (
            <PlanPriceCard
                plan={plan}
                price={price}
                info={info}
                hint={hint}
            />
        )
    }

    renderPlanSelectButton = (plan) => {
        return (
            <Button
                variant="primary"
                className="lg"
                onClick={() => this.handleSelectPlan(plan)}
            >
                Select {plan}
            </Button>
        )
    }

    /**
     * Handlers
     */

    handleSelectPlan = (plan) => {
        this.props.onSelect(plan)
    }

    /**
     * Props
     */

    static defaultProps = {
        showButtons: true,
        onSelect: console.log,
        features: [
            'Access to all Videos',
            'Talent Search',
            'Player Evaluation',
            'Scouting Reports',
            'Report Sharing',
            'Player Stats Per Match',
            'Player Comparision',
            'Watch List',
            'Matches and Events',
            'Messaging',
        ],
        plans: {
            platinum: {
                features: [
                    { name: 'Access to all Videos', available: true },
                    { name: 'Talent Search', available: true },
                    { name: 'Player Evaluation', available: true },
                    { name: 'Scouting Reports', available: true },
                    { name: 'Report Sharing', available: true },
                    { name: 'Player Stats Per Match', available: true },
                    { name: 'Player Comparision', available: true },
                    { name: 'Watch List', available: true },
                    { name: 'Matches and Events', available: true },
                    { name: 'Messaging', available: true },
                ],
                price: 600,
                info: 'Per year, If paid annually',
                hint: '$60/month if Paid monthly'
            },
            gold: {
                features: [
                    { name: 'Access to all Videos', available: true },
                    { name: 'Talent Search', available: true },
                    { name: 'Player Evaluation', available: true },
                    { name: 'Scouting Reports', available: true },
                    { name: 'Report Sharing', available: true },
                    { name: 'Player Stats Per Match', available: true },
                    { name: 'Player Comparision', available: false },
                    { name: 'Watch List', available: false },
                    { name: 'Matches and Events', available: false },
                    { name: 'Messaging', available: false },
                ],
                price: 500,
                info: 'Per year, If paid annually',
                hint: '$45/month if Paid monthly'
            },
            silvar: {
                features: [
                    { name: 'Access to all Videos', available: true },
                    { name: 'Talent Search', available: true },
                    { name: 'Player Evaluation', available: true },
                    { name: 'Scouting Reports', available: true },
                    { name: 'Report Sharing', available: false },
                    { name: 'Player Stats Per Match', available: false },
                    { name: 'Player Comparision', available: false },
                    { name: 'Watch List', available: false },
                    { name: 'Matches and Events', available: false },
                    { name: 'Messaging', available: false },
                ],
                price: 300,
                info: 'Per year, If paid annually',
                hint: '$30/month if Paid monthly'
            },
            bronze: {
                features: [
                    { name: 'Access to all Videos', available: true },
                    { name: 'Talent Search', available: true },
                    { name: 'Player Evaluation', available: true },
                    { name: 'Scouting Reports', available: false },
                    { name: 'Report Sharing', available: false },
                    { name: 'Player Stats Per Match', available: false },
                    { name: 'Player Comparision', available: false },
                    { name: 'Watch List', available: false },
                    { name: 'Matches and Events', available: false },
                    { name: 'Messaging', available: false },
                ],
                price: 200,
                info: 'Per year, If paid annually',
                hint: '$20/month if Paid monthly'
            },
        }
    }
}

export default PlansCompareFeatures
